import React from 'react';
import { Tooltip } from "@mui/material";
import { TooltipName } from "../../../utils/Enums";
import { useSetMultipleParams } from '../../../hooks/useSetMultipleParams';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';


  const ParentCardKeys = React.memo(({ project, boardName, isAssignedUser, boardKey, handleDetails, isMyTaskCard=false ,openDetailCard = () => {} }) => {
    const {
      card,
      board_permission: projectBoardPermission,
      board_admin,
      board_name,
      key: boardUniqueKey,
    } = project || {};
    const {
      assigned_to_user,
      card_id,
      board_id,
      reporter,
      is_card_collaborator,
    } = card || {};
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
  const [setMultipleSearchParams] = useSetMultipleParams();
  const location = useLocation();

  if (!project?.card?.parent_card_id || isAssignedUser) {
    return null;
  }

  const handleParentClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    
    // Check if modifier keys are pressed (Cmd/Ctrl or Shift)
    const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
    
    if (isMyTaskCard) {
      if (isModifierPressed) {
        const params = new URLSearchParams();
        params.set("card_id",  project?.card?.parent_card_id);
        params.set("brd_id",   board_id);
        window.open(
          `${window.location.pathname}?${params.toString()}`,
          "_blank"
        );
        event.stopPropagation();
        return;
      }

      setMultipleSearchParams([
        { name: "card_id", value: project?.card?.parent_card_id },
        { name: "brd_id", value: board_id },
      ]);
      openDetailCard?.();
    } else if (!isAssignedUser) {
      const url = `/board/${boardKey || boardUniqueKey}/${
        boardKey || boardUniqueKey
      }-${project?.card?.parent_card_id}?${searchParams.toString()}`;

      if (isModifierPressed) {
        window.open(url, "_blank");
        event.stopPropagation();
        return;
      }
      navigate(url);
    } else {
      event.stopPropagation();
    }
  }

  return (
    <Tooltip title={TooltipName.OPEN_PARENT_TASK_DETAIL}>
      <span className="related_time parent-title-id mb-2 cursor-pointer" onClick={handleParentClick}>
        {boardName?.key || boardKey || project?.key}-{project?.card?.parent_card_id}
      </span>
    </Tooltip>
  );
});

ParentCardKeys.displayName = 'ParentCardKeys';

export default ParentCardKeys; 